import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LanguageServiceService } from '../../services/language-service.service';
import { LanguagesService } from '../../services/languages.service';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../components/Authentication/auth/login.service';
import { LogoutService } from '../../components/Authentication/auth/logout.service';
import { UserService } from '../../services/user';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header.mobile.component.html',
  styleUrl: './header.mobile.component.scss',
})
export class HeaderMobileComponent implements OnInit, AfterViewInit {
  @Input() isActive!: boolean;
  currentLanguage!: string | null;
  token!: string | null;
  contentReady: boolean = true;
  accountType: string = '';
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;
  isDeliveryHero: boolean = false;
  showAllUsers: boolean = false;
  isEmployee: boolean = false;
  cartItems: any[] = [];
  cartItemCount: number = 0;
  cartPopUp: boolean = false;
  showCart: boolean = false;
  openMenu: boolean = false;
  isfinancialEmployee: boolean = false;
  lang = [
    { code: 'ar', name: 'arabic' },
    { code: 'ar', name: 'arabic' },
  ];
  tokenExists!: boolean;
  @ViewChild('navbarNav') navbarNav!: ElementRef;

  constructor(
    private translate: TranslateService,
    private _languageService: LanguageServiceService,
    private _LoginService: LoginService,
    private _logoutService: LogoutService,

    private _userService: UserService,
    private location: Location,
    private router: Router
  ) {
    translate.addLangs(['ar', 'ar']);
    translate.setDefaultLang('ar');
    this.currentLanguage = translate.getDefaultLang();
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang?.match(/ar|ar/) ? browserLang : 'ar');
    const path = this.location.path();
    if (path.includes('/Addorder') || path.includes('/Home'))
      this.showCart = false;
    else
      this.showCart = true;
  }
  showPopup: boolean = false;
  openMenuToggle() {
    this.openMenu = !this.openMenu;
  }
  openPopup() {
    this.showPopup = true;
  }
  close(): void {
    this.openMenu = false;
    this.cartPopUp = false;
  }
  removeFromCart(e: any) {
    const index = this.cartItems.findIndex(item => item.id === e.id); // assuming 'id' is unique
    if (index !== -1) {
      // Item exists → remove it
      this.cartItems.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(this.cartItems));
    }
    this.cartItemCount = this.cartItems.length;
    if (this.cartItems.length == 0) {
      this.cartPopUp = false;
      this.cartItemCount = 0;
    }
  }
  quickOrder() {

    this.router.navigate(['/Addorder'], {
      queryParams: {
        cart: JSON.stringify(this.cartItems)
      }
    });
  }
  cartPopUpOpen() {
    this.cartPopUp = true;
  }
  closePopup() {
    this.showPopup = false;

  }
  logout() {

    this.contentReady = true;

    return this._logoutService.logout(this.token).subscribe({
      next: (res) => {
        localStorage.removeItem('cart');

        localStorage.removeItem('token');

        window.location.reload();
      },
      error: (err) => {
        this.contentReady = false;

      },
    });


  }
  ngAfterViewInit() {
    const navLinks = this.navbarNav.nativeElement.querySelectorAll('.nav-item');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    navLinks.forEach((link: HTMLElement) => {
      link.addEventListener('click', () => {
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          const navbarToggler = document.querySelector(
            '.navbar-toggler'
          ) as HTMLElement;
          navbarToggler.click(); // This will trigger the collapse
        }
      });
    });
  }
  toggleLanguage() {
    this.currentLanguage = this.currentLanguage === 'ar' ? 'ar' : 'ar';
    this.translate.use(this.currentLanguage);
    localStorage.setItem('language', this.currentLanguage);

    this._languageService.toggleLanguage();
  }
  ngOnInit(): void {
    this.showCart = true;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.token = localStorage.getItem('token');

        this._userService.getAccountType().subscribe({
          next: (data) => {

            this.isAdmin = false;
            this.isSubAdmin = false;
            this.isfinancialEmployee = false;
            this.isEmployee = false;
            this.showAllUsers = false;

            this.accountType = data['user_type'];
            if (this.accountType == "1") {
              this.isAdmin = true;
              this.showAllUsers = true;
            }
            if (this.accountType == "6") {
              this.isSubAdmin = true;
            }
            if (this.accountType == "2") {
              this.isfinancialEmployee = true;
            }
            if (this.accountType == "7") {
              this.isEmployee = true;
            }
          },
          error: (error) => {
            localStorage.clear();         // يمسح كل الداتا من localStorage
  localStorage.setItem('language', 'ar');
          }
        });
      }
      let storedCart = localStorage.getItem("cart");
      if (storedCart) {
        this.cartItems = JSON.parse(storedCart);
        this.cartItemCount = this.cartItems.length;
      }
      else {
        this.cartItemCount = 0;
      }
    });



    this._languageService.currentLanguage$.subscribe((language) => {
      this.currentLanguage = language;
    });

    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      this.translate.use(savedLang);
    }
    this.checkForToken();
  }
  help() {
    this.openPopup();
  }
  checkForToken() {
    this._LoginService.token$.subscribe((token) => {
      // Update the tokenExists flag based on the token presence
      this.tokenExists = token != null;
    });
  }
  userType() {
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
      },
      error: (error) => console.error(error),
    });

  }

}
